import type { SxProps, Theme } from '@mui/material'
import { alpha } from '@mui/material'

import type { BidDetailRowState } from '@/features/bidding/utils/bidDetail/getRowStateClasses'

/**
 * Theme-driven `sx` mapping for the row state.
 *
 * State precedence on the row background:
 * 1. `under-offered` → red tint (most urgent — applies to entire PTU)
 * 2. `activated` → green tint
 * 3. `now` → primary tint (current PTU)
 * 4. `past` → muted (default)
 *
 * Uses theme palette tokens — never raw hex values from the V7 mockup.
 */
export function getRowStateSx(state: BidDetailRowState): SxProps<Theme> {
  return (theme) => {
    if (state.underOffered) {
      return {
        backgroundColor: alpha(theme.palette.error.light, 0.18),
        '&:hover': { backgroundColor: alpha(theme.palette.error.light, 0.26) },
      }
    }
    if (state.activated) {
      return {
        backgroundColor: alpha(theme.palette.success.light, 0.18),
        '&:hover': { backgroundColor: alpha(theme.palette.success.light, 0.26) },
      }
    }
    if (state.now) {
      return {
        backgroundColor: alpha(theme.palette.primary.light, 0.16),
        '&:hover': { backgroundColor: alpha(theme.palette.primary.light, 0.24) },
      }
    }
    if (state.past) {
      return {
        backgroundColor: alpha(theme.palette.action.disabledBackground, 0.2),
        color: theme.palette.text.secondary,
      }
    }

    return {}
  }
}
